import { Controller } from "@hotwired/stimulus"

// Floats a <details> dropdown panel OVER the page instead of growing the row
// it sits in (attach to the <details>, mark the panel with a panel target).
// The panel is position: fixed so .table-wrapper's overflow can't clip it; on
// open it is anchored just below the summary button (or above, when there's
// no room below). Repositions while scrolling/resizing and closes on outside
// click or Esc — native <details> only closes on a second summary click.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.onOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    this.onEscape = (event) => {
      if (event.key === "Escape") this.close()
    }
    this.reposition = () => this.position()
  }

  disconnect() {
    this.teardown()
  }

  // Fired by the native `toggle` event after the open state flips.
  toggle() {
    if (this.element.open) {
      this.position()
      document.addEventListener("click", this.onOutsideClick)
      document.addEventListener("keydown", this.onEscape)
      window.addEventListener("scroll", this.reposition, true) // capture: inner scrollers too
      window.addEventListener("resize", this.reposition)
    } else {
      this.teardown()
    }
  }

  close() {
    this.element.open = false // fires toggle → teardown
  }

  teardown() {
    document.removeEventListener("click", this.onOutsideClick)
    document.removeEventListener("keydown", this.onEscape)
    window.removeEventListener("scroll", this.reposition, true)
    window.removeEventListener("resize", this.reposition)
  }

  position() {
    const button = this.element.querySelector("summary").getBoundingClientRect()
    const panel = this.panelTarget
    const margin = 8

    const width = Math.min(320, window.innerWidth - margin * 2)
    panel.style.width = `${width}px`

    const height = panel.offsetHeight
    const below = button.bottom + 6
    const top = below + height > window.innerHeight && button.top - height - 6 > 0
      ? button.top - height - 6 // not enough room below — open upward
      : below
    panel.style.top = `${top}px`

    const left = Math.min(Math.max(margin, button.left), window.innerWidth - width - margin)
    panel.style.left = `${left}px`
  }
}
